<br />
<img alt="FMEA" class="system-logo" src="assets/images/logos/logo_transparent.png" />
<br />
<div class="login-container clearfix divider-content">
	<form #myForm (submit)="onSubmit()" [formGroup]="loginForm">
		<div class="row">
			<pcg-control-group class="col-sm-12" label="Username">
				<input pcgControlRef formControlName="userName" type="text" class="form-control" />
			</pcg-control-group>
		</div>
		<pcg-show-hide-password [controlName]="'password'" [parentForm]="loginForm" [label]="'Password'" [inputCssClass]="'form-control'"></pcg-show-hide-password>
		<button type="submit" class="btn btn-save btn-lg">Login</button>
		<a class="float-right" routerLink="/forgot-password">Forgot your password?</a>
	</form>
</div>
